import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import {
  Button,
  Dialog,
  DialogSurface,
  DialogTitle,
  DialogBody,
  DialogActions,
  DialogContent,
  Input,
  Field,
} from "@fluentui/react-components";
import { EditRegular } from "@fluentui/react-icons";

const StyledDialogSurface = styled(DialogSurface)`
  max-width: 400px;
  width: 90vw;
`;

const FormGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

interface EditTransportingExpensesDialogProps {
  open: boolean;
  onClose: () => void;
  onSave: (transportingExpenses: string | null) => void;
  insurer: string;
  transportingExpenses?: string | null;
}

export const EditTransportingExpensesDialog = ({
  open,
  onClose,
  onSave,
  insurer,
  transportingExpenses,
}: EditTransportingExpensesDialogProps) => {
  const { t } = useTranslation();
  const [value, setValue] = useState("");

  useEffect(() => {
    if (open) {
      setValue(transportingExpenses || "");
    }
  }, [open, transportingExpenses]);

  const handleSave = () => {
    // Keep as string, or null if empty
    onSave(value || null);
    onClose();
  };

  return (
    <Dialog open={open} onOpenChange={(e, data) => data.open || onClose()}>
      <StyledDialogSurface>
        <DialogBody>
          <DialogTitle>
            <EditRegular style={{ marginRight: "8px" }} />
            {t(
              "qtg.casco.editTransportingExpenses.title",
              "Edit Transporting Expenses"
            )}
          </DialogTitle>
          <DialogContent>
            <FormGrid>
              <div>
                <strong>
                  {t("qtg.casco.editTransportingExpenses.insurer", "Insurer")}:
                </strong>{" "}
                {insurer}
              </div>
              <div style={{ fontSize: "12px", color: "#666" }}>
                {t(
                  "qtg.casco.editTransportingExpenses.note",
                  "This will update all variants and payment options for this insurer"
                )}
              </div>

              <Field
                label={t(
                  "qtg.casco.table.transportingExpenses",
                  "Transporting Expenses"
                )}
              >
                <Input
                  type="number"
                  value={value}
                  onChange={(e) => setValue(e.target.value)}
                  placeholder={t(
                    "qtg.casco.editTransportingExpenses.placeholder",
                    "Enter amount"
                  )}
                />
              </Field>
            </FormGrid>
          </DialogContent>
          <DialogActions>
            <Button appearance="secondary" onClick={onClose}>
              {t("qtg.common.cancel", "Cancel")}
            </Button>
            <Button appearance="primary" onClick={handleSave}>
              {t("qtg.common.save", "Save")}
            </Button>
          </DialogActions>
        </DialogBody>
      </StyledDialogSurface>
    </Dialog>
  );
};
